import { selectedFacets } from '@lumapps/search/types';

export enum TrackingEventType {
    SEARCH = 'search',
    SEARCH_FILTER = 'search_filter',
    SEARCH_LOAD_MORE = 'search_load_more',
    SEARCH_CLICK = 'search_click',
    SEARCH_CLICK_PREVIEW = 'search_click_preview',
    CLICK_ACTION = 'click_action',
}

export enum TrackingAppType {
    IOS = 'ios',
    ANDROID = 'android',
    RESPONSIVE = 'responsive',
    DESKTOP = 'desktop',
    EXTERNAL = 'external',
}

export enum TrackingReferrerType {
    EMAIL = 'email',
    NOTIFICATION = 'notification',
    LINK = 'link',
    MOBILE_APP = 'mobile-app',
}

export enum TargetType {
    ORGANIZATION = 'organization',
    SITE = 'site',
    COMMUNITY = 'community',
    POST = 'post',
    CONTENT = 'content',
    COMMENT = 'comment',
    USER = 'user',
    GROUP = 'group',
    ARTICLE = 'article',
    EVENT = 'event',
    EXTERNAL_LINK = 'external_link',
    PLAY_VIDEO = 'play_video',
    PLAYLIST = 'playlist',
    DIRECTORY_ENTRY = 'directory_entry',
    MOBILE = 'mobile',
    SEARCH = 'search',
    PROGRAM = 'program',
    MEDIA = 'media',
    SEARCH_EXTENSION = 'search_extension',
    SHAREABLE_CONTENT = 'shareable_content',
    ASK_REACTION = 'ask_reaction',
}

export enum SearchDocumentType {
    PLAY_VIDEO = 'video',
    PLAY_PLAYLIST = 'video-playlist',
    USER = 'user',
    CONTENT = 'content',
    POST = 'post',
    COMMUNITY = 'community',
    ARTICLE = 'entity.article',
    EVENT = 'event',
    DIRECTORY_ENTRY = 'directoryentry',
    MEDIA = 'media',
    EXTENSION = 'extension',
}

export type LumappsTrackingEventAction = {
    type: TrackingEventType;
    query: string;
    resultCount: number;
    searchEngine: string | null;
    extensionId?: string;
    sortedBy?: string;
    tabId?: string;
    promotedIds?: string[];
    filters?: selectedFacets;
    position?: number;
    isPromoted?: boolean;
    targetType?: string;
    targetId?: string;
    title?: string;
    url?: string;
    thumbnail?: string;
};

export type LumappsTrackingSearchClickEventAction = {
    type: TrackingEventType;
    query: string;
    tabId?: string;
    resultCount: number;
    isPromoted: boolean;
    position: number;
    targetId: string;
    targetType: SearchDocumentType;
};

export type LumappsTrackingClickAction = {
    targetId: string;
    targetType: TargetType;
    url?: string;
    thumbnail?: string;
    title?: string;
};

export type LumappsTrackingAskReaction = {
    type: TargetType.ASK_REACTION;
    reactionType: string;
    traceId: string;
};

export interface LumappsTrackingEventContext {
    siteId?: string;
    app: {
        type?: TrackingAppType;
        branding?: string;
        version: string;
        build?: string;
    };
    locale?: string;
    page?: {
        path?: string;
        referrer?: string;
        search?: string;
        title?: string;
        url?: string;
    };
    referrer?: {
        type?: TrackingReferrerType;
        name?: string;
        url?: string;
        link?: string;
    };
    screen?: {
        width?: string;
        height?: string;
        density?: string;
    };
    timezone?: string;
}

export type LumappsTrackingActionType =
    | LumappsTrackingEventAction
    | LumappsTrackingClickAction
    | LumappsTrackingAskReaction;

export interface LumappsTrackingEvent {
    action: LumappsTrackingActionType;
    sessionId: string;
    performedAt: string;
    context: LumappsTrackingEventContext;
}

export interface Config {
    apiUrl: string;
}

export interface LumappsPageViewEventPayload {
    id?: string;
    status?: string;
}

export interface LumappsTrackEventPayload {
    action: LumappsTrackingActionType;
}

export interface SessionId {
    id: string;
    ttl: string;
}
